import { Col, Row } from 'reactstrap';

import { ConfigProvider } from 'antd';

import img2 from '../assets/images/diagri-background.png';
import AuthAside from '../views/authentication/AuthAside';

const sidebarBackground = {
  backgroundImage: 'url(' + img2 + ')',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center center'
};

function AuthLayout({ asideContent, children }) {
  return (
    <ConfigProvider
      theme={{
        components: {
          Form: {
            verticalLabelPadding: '0 0 0.5rem 0',
            itemMarginBottom: '1.5rem'
          }
        }
      }}>
      <div className="auth-wrapper  align-items-center d-flex" style={sidebarBackground}>
        <div className="container">
          <Row className="no-gutters justify-content-center">
            <Col md="6" lg="5" className="bg-dark">
              <AuthAside {...asideContent} />
            </Col>
            <Col md="6" lg="5" className="bg-white p-5">
              {children}
            </Col>
          </Row>
        </div>
      </div>
    </ConfigProvider>
  );
}

export default AuthLayout;
